@if (unavailability(); as unavailability) {
  <onyx-icon
    class="gray"
    [name]="icon()!"
    [size]="20"
    [onyxTooltip]="tooltipTemplate"
    [onyxTooltipTemplateContext]="{ unavailability }"
    onyxTooltipColor="white"
  ></onyx-icon>
}

<ng-template let-unavailability="unavailability" #tooltipTemplate>
  <div class="tooltip">
    <div class="heading">
      <onyx-icon class="gray" [name]="icon()!" [size]="20"></onyx-icon>

      <p class="f-body-s f-medium">
        {{
          `${DictionaryCode.EMPLOYEE_UNAVAILABILITY_REASON}.${unavailability.reason}`
            | translate
        }}
      </p>
    </div>

    <div class="range f-muted">
      <span>
        {{ 'labels.from' | translate }}
        {{ unavailability.dateRange.from | onyxDate: 'date-dot' }}
      </span>

      <span>
        {{ 'labels.to' | translate | lowercase }}
        {{ unavailability.dateRange.to | onyxDate: 'date-dot' }}
      </span>
    </div>
  </div>
</ng-template>
